export const Roles = {
    // Base roles
    Admin: "Admin",
    SuperAdmin: "SuperAdmin",
    Administrator: "Administrator",
    Investor: "Investor",
    Manager: "Manager",

    // Admin Controller - All endpoints require roles (including GET)
    AdminRead: "AdminRead",
    AdminCreate: "AdminCreate",
    AdminUpdate: "AdminUpdate",
    AdminDelete: "AdminDelete",
    AdminChangePassword: "AdminChangePassword",

    // Users Controller - CUD operations require roles, GET is public
    UserCreate: "UserCreate",
    UserUpdate: "UserUpdate",
    UserDelete: "UserDelete",
    UserChangeType: "UserChangeType",
    UserChangePassword: "UserChangePassword",

    // News Controller - CUD operations require roles, GET is public
    NewsCreate: "NewsCreate",
    NewsUpdate: "NewsUpdate",
    NewsDelete: "NewsDelete",
    NewsManageImages: "NewsManageImages",

    // Projects Controller - CUD operations require roles, GET is public
    ProjectCreate: "ProjectCreate",
    ProjectUpdate: "ProjectUpdate",
    ProjectDelete: "ProjectDelete",

    // Branches Controller - CUD operations require roles, GET is public
    BranchCreate: "BranchCreate",
    BranchUpdate: "BranchUpdate",
    BranchDelete: "BranchDelete",

    // Investments Controller - All operations require roles
    InvestmentRead: "InvestmentRead",
    InvestmentCreate: "InvestmentCreate",
    InvestmentUpdate: "InvestmentUpdate",
    InvestmentDelete: "InvestmentDelete",
    InvestmentStatistics: "InvestmentStatistics",

    // ProfitRoll Controller - All operations require roles
    ProfitRollRead: "ProfitRollRead",
    ProfitRollCreate: "ProfitRollCreate",
    ProfitRollUpdate: "ProfitRollUpdate",
    ProfitRollDelete: "ProfitRollDelete",
    ProfitRollApprove: "ProfitRollApprove",
    ProfitRollManageMessage: "ProfitRollManageMessage",

    // Notifications Controller - Admin operations require roles
    NotificationReadAll: "NotificationReadAll",
    NotificationDelete: "NotificationDelete",

    // Common Questions Controller - CUD operations require roles, GET is public
    CommonQuestionCreate: "CommonQuestionCreate",
    CommonQuestionDelete: "CommonQuestionDelete",

    // Sliders Controller - CUD operations require roles, GET is public
    SliderCreate: "SliderCreate",
    SliderDelete: "SliderDelete",

    // Excel Controller - All operations require roles
    ExcelExport: "ExcelExport",

    // Upload Controller - All operations require roles
    FileUpload: "FileUpload",
};

export const CustomRoles = [
    // Base roles
    { EnCaption: "Admin", ArCaption: "المسؤول", Name: Roles.Admin },
    {
        EnCaption: "SuperAdmin",
        ArCaption: "المدير العام",
        Name: Roles.SuperAdmin,
    },
    {
        EnCaption: "Administrator",
        ArCaption: "المشرف",
        Name: Roles.Administrator,
    },
    { EnCaption: "Investor", ArCaption: "المستثمرين", Name: Roles.Investor },
    { EnCaption: "Manager", ArCaption: "الاداري", Name: Roles.Manager },

    // Admin Controller roles
    {
        EnCaption: "Admin Read",
        ArCaption: "قراءة المشرفين",
        Name: Roles.AdminRead,
    },
    {
        EnCaption: "Admin Create",
        ArCaption: "إنشاء مشرف",
        Name: Roles.AdminCreate,
    },
    {
        EnCaption: "Admin Change Password",
        ArCaption: "تغيير كلمة مرور المشرف",
        Name: Roles.AdminChangePassword,
    },
    {
        EnCaption: "Admin Update",
        ArCaption: "تعديل مشرف",
        Name: Roles.AdminUpdate,
    },
    {
        EnCaption: "Admin Delete",
        ArCaption: "حذف مشرف",
        Name: Roles.AdminDelete,
    },

    // Users Controller roles
    {
        EnCaption: "User Create",
        ArCaption: "إنشاء مستخدم",
        Name: Roles.UserCreate,
    },
    {
        EnCaption: "User Update",
        ArCaption: "تعديل مستخدم",
        Name: Roles.UserUpdate,
    },
    {
        EnCaption: "User Delete",
        ArCaption: "حذف مستخدم",
        Name: Roles.UserDelete,
    },
    {
        EnCaption: "User Change Type",
        ArCaption: "تغيير نوع المستخدم",
        Name: Roles.UserChangeType,
    },
    {
        EnCaption: "User Change Password",
        ArCaption: "تغيير كلمة مرور المستخدم",
        Name: Roles.UserChangePassword,
    },

    // News Controller roles
    {
        EnCaption: "News Create",
        ArCaption: "إنشاء خبر",
        Name: Roles.NewsCreate,
    },
    {
        EnCaption: "News Update",
        ArCaption: "تعديل خبر",
        Name: Roles.NewsUpdate,
    },
    { EnCaption: "News Delete", ArCaption: "حذف خبر", Name: Roles.NewsDelete },
    {
        EnCaption: "News Manage Images",
        ArCaption: "إدارة صور الأخبار",
        Name: Roles.NewsManageImages,
    },

    // Projects Controller roles
    {
        EnCaption: "Project Create",
        ArCaption: "إنشاء مشروع",
        Name: Roles.ProjectCreate,
    },
    {
        EnCaption: "Project Update",
        ArCaption: "تعديل مشروع",
        Name: Roles.ProjectUpdate,
    },
    {
        EnCaption: "Project Delete",
        ArCaption: "حذف مشروع",
        Name: Roles.ProjectDelete,
    },

    // Branches Controller roles
    {
        EnCaption: "Branch Create",
        ArCaption: "إنشاء فرع",
        Name: Roles.BranchCreate,
    },
    {
        EnCaption: "Branch Update",
        ArCaption: "تعديل فرع",
        Name: Roles.BranchUpdate,
    },
    {
        EnCaption: "Branch Delete",
        ArCaption: "حذف فرع",
        Name: Roles.BranchDelete,
    },

    // Investments Controller roles
    {
        EnCaption: "Investment Read",
        ArCaption: "قراءة الاستثمارات",
        Name: Roles.InvestmentRead,
    },
    {
        EnCaption: "Investment Create",
        ArCaption: "إنشاء استثمار",
        Name: Roles.InvestmentCreate,
    },
    {
        EnCaption: "Investment Update",
        ArCaption: "تعديل استثمار",
        Name: Roles.InvestmentUpdate,
    },
    {
        EnCaption: "Investment Delete",
        ArCaption: "حذف استثمار",
        Name: Roles.InvestmentDelete,
    },
    {
        EnCaption: "Investment Statistics",
        ArCaption: "إحصائيات الاستثمارات",
        Name: Roles.InvestmentStatistics,
    },

    // ProfitRoll Controller roles
    {
        EnCaption: "ProfitRoll Read",
        ArCaption: "قراءة لفة الأرباح",
        Name: Roles.ProfitRollRead,
    },
    {
        EnCaption: "ProfitRoll Create",
        ArCaption: "إنشاء لفة أرباح",
        Name: Roles.ProfitRollCreate,
    },
    {
        EnCaption: "ProfitRoll Update",
        ArCaption: "تعديل لفة الأرباح",
        Name: Roles.ProfitRollUpdate,
    },
    {
        EnCaption: "ProfitRoll Delete",
        ArCaption: "حذف لفة الأرباح",
        Name: Roles.ProfitRollDelete,
    },
    {
        EnCaption: "ProfitRoll Approve",
        ArCaption: "اعتماد لفة الأرباح",
        Name: Roles.ProfitRollApprove,
    },
    {
        EnCaption: "ProfitRoll Manage Message",
        ArCaption: "إدارة رسائل الأرباح",
        Name: Roles.ProfitRollManageMessage,
    },

    // Notifications Controller roles
    {
        EnCaption: "Notification Read All",
        ArCaption: "قراءة جميع الإشعارات",
        Name: Roles.NotificationReadAll,
    },
    {
        EnCaption: "Notification Delete",
        ArCaption: "حذف إشعار",
        Name: Roles.NotificationDelete,
    },

    // Common Questions Controller roles
    {
        EnCaption: "Common Question Create",
        ArCaption: "إنشاء سؤال شائع",
        Name: Roles.CommonQuestionCreate,
    },
    {
        EnCaption: "Common Question Delete",
        ArCaption: "حذف سؤال شائع",
        Name: Roles.CommonQuestionDelete,
    },

    // Sliders Controller roles
    {
        EnCaption: "Slider Create",
        ArCaption: "إنشاء سلايدر",
        Name: Roles.SliderCreate,
    },
    {
        EnCaption: "Slider Delete",
        ArCaption: "حذف سلايدر",
        Name: Roles.SliderDelete,
    },

    // Excel Controller roles
    {
        EnCaption: "Excel Export",
        ArCaption: "تصدير إكسل",
        Name: Roles.ExcelExport,
    },

    // Upload Controller roles
    { EnCaption: "File Upload", ArCaption: "رفع ملف", Name: Roles.FileUpload },
];
